var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label-width":_vm.currentField.labelWidth + 'px'}},[_c('el-button',{staticClass:"form__button",attrs:{"type":"primary"}},[_vm._v(_vm._s(_vm.currentField.buttonText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }